import util from '@bmp-vue/core/api/util'

const controller = 'ContaMonitorada';

export default Object.assign({}, util.GetCrud(controller, ['getall']), {
    ImportarContas: function (dto) {
      return util.Axios.PostForm(`${controller}/CriarContasImportacao`, dto)
    },
    ImportarAtualizacaoContas: function(dto) {
      return util.Axios.PostForm(`${controller}/AtualizarContasImportacao`, dto)
    },
    Post: function(dto) {
      return util.Axios.Post(`${controller}/CriarConta`, dto);
    },
    Put: function(id, dto) {
      return util.Axios.Put(`${controller}/AtualizarConta`, id, dto);
    }
}); 